export const SKELETON_CONFIG = [
  { id: 'title', width: 100 },
  { id: 'subtitle', width: 100 },
  { id: 'primary-value', width: 60 },
  { id: 'secondary-value', width: 60 }
];
export const SKELETON_ELEMENT_HEIGHT = 280;
